import React from "react";
import About from "../components/About";
import WhySelectra from "../components/WhySelectra";
import Testimonials from "../components/Testimonials";
import FinalCTA from "../components/FinalCTA";
import PageHero from "../components/PageHero";

export default function AboutPage() {
  return (
    <>
      <PageHero
        eyebrow="About Selectra"
        title={["WE DESIGN", "ENERGY, NOT JUST", "INSTALLATIONS."]}
        subtitle="Two locations, one engineering standard — built on quality, precision and long-term thinking."
      />
      <About />
      <WhySelectra />
      <Testimonials />
      <FinalCTA />
    </>
  );
}
